export const environment = {
  production: false,
  gtagId: '',
  isToHidePromocode: false,
};
